import type { NotificationOptionsTyped } from 'element-plus'
import { ElNotification } from 'element-plus'
import { isString       } from '@vue/shared'

/** loading 用户数据加载,页面转场... */
export const successNotice = CreateNotice('success')
export const warningNotice = CreateNotice('warning')
export const infoNotice    = CreateNotice('info')
export const errorNotice   = CreateNotice('error')

// 创建通知函数
function CreateNotice(type: 'success' | 'warning' | 'info' | 'error') {
    return (options: string | NotificationOptionsTyped, title = '通知') => {
        const _options_ = isString(options) ? { message: options } : options
        
        ElNotification[type]({ ..._options_, title })
    }
}
